<div class="alert-box">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="onCloseModal()">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">{{ "block_copying" | translate }}</h4>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label for="siteSelect">{{ "select site_or_page" | translate }}</label>
            <ng-select
                class="sp-ng-select"
                [class.btn-loading]="(sitesStatuses$ | async)?.isLoading"
                bindLabel="name"
                bindValue="id"
                groupBy="pages"
                [placeholder]="'select site_or_page' | translate"
                [(ngModel)]="pageIds"
                [items]="sites$ | async"
                [multiple]="true"
                [selectableGroup]="true"
                [selectableGroupAsModel]="false"
                id="siteSelect"
            >
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of items | slice: 0 : 3">
                        <span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
                        <span class="ng-value-label">{{ item.name }}</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 3">
                        <span class="ng-value-label">{{ items.length - 3 }} more...</span>
                    </div>
                </ng-template>

                <ng-template ng-optgroup-tmp let-item="item">
                    <!-- bold  is current site -->
                    <strong *ngIf="currentSiteId === item.id.toString()">
                        {{ "site" | translate }} «{{ item.name }}»
                    </strong>
                    <ng-container *ngIf="currentSiteId !== item.id.toString()">
                        {{ "site" | translate }} «{{ item.name }}»
                    </ng-container>
                </ng-template>

                <ng-template ng-option-tmp let-item="item"> {{ "page" | translate }} «{{ item.name }}» </ng-template>
            </ng-select>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-default" [disabled]="loading" (click)="onCancel()">
            {{ "cancel" | translate }}
        </button>
        <button
            type="button"
            class="btn btn-primary"
            [disabled]="!pageIds.length"
            [class.btn-loading]="loading"
            (click)="onConfirm()"
        >
            {{ "copy" | translate }}
        </button>
    </div>
</div>
